import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

function EmpPackagesPage() {
    const { t } = useTranslation();
    const [payments, setPayments] = useState([]);

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                const res = await axiosInstance.get(`${API_URL}/getAllPayments`); // Use your actual API endpoint
                setPayments(res.data.data);
            } catch (err) {
                console.error("Failed to fetch payments", err);
            }
        };

        fetchPayments();
    }, []);

    return (
        <>
            <Helmet>
                <title>Payments | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="wt-admin-right-page-header clearfix">
                <h2>{t("Payments")}</h2>
                <div className="breadcrumbs"><a href="#">{t("Home")}</a><a href="#">{t("Dashboard")}</a><span>{t("Payments")}</span></div>
            </div>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />{t("Payments")}</h4>
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        <table className="table twm-table table-striped table-borderless">
                            <thead>
                                <tr>
                                    <th>{t("Id")}</th>
                                    <th>{t("Package Name")}</th>
                                    {/* <th>Subscription Id</th> */}
                                    <th>{t("Transaction Id")}</th>
                                    {/* <th>Price</th> */}
                                    <th>{t("Amount")}</th>
                                    {/* <th>Source</th> */}
                                    {/* <th>Status</th> */}
                                    <th>{t("Payment Status")}</th>
                                    {/* <th>Expired</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {payments.length > 0 ? payments.map((payment, idx) => (
                                    <tr key={idx}>
                                        <td>{payment.id}</td>
                                        <td>
                                            <a href="javascript:void(0);" className="site-text-primary">
                                                {payment.transaction_data?.metadata?.planName || 'N/A'}
                                            </a>
                                        </td>
                                        {/* <td>{payment.subscription_id || '—'}</td> */}
                                        <td>{payment.transaction_id || '—'}</td>
                                        {/* <td>{payment.price}</td> */}
                                        <td>{payment.total_amount}</td>
                                        {/* <td>{payment.source}</td> */}
                                        <td>
                                            <span className={payment.payment_status === 'paid' ? "text-clr-green2" : "text-clr-red"}>
                                                {payment.payment_status}
                                            </span>
                                        </td>
                                        {/* <td>
                                            <span className={payment.payment_status === 'paid' ? "text-clr-green2" : "text-clr-red"}>
                                                {payment.payment_status}
                                            </span>
                                        </td> */}
                                        {/* <td>{new Date(payment.created_at).toLocaleDateString()}</td> */}
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="9" className="text-center">{t("No payments found.")}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpPackagesPage;









// function EmpPackagesPage() {
//     return (
//         <>
//             <div className="wt-admin-right-page-header clearfix">
//                 <h2>Payments</h2>
//                 <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dasboard</a><span>Payments</span></div>
//             </div>
//             <div className="panel panel-default site-bg-white m-t30">
//                 <div className="panel-heading wt-panel-heading p-a20">
//                     <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Payments</h4>
//                 </div>
//                 <div className="panel-body wt-panel-body">
//                     <div className="p-a20 table-responsive">
//                         <table className="table twm-table table-striped table-borderless">
//                             <thead>
//                                 <tr>
//                                     <th>Package Name</th>
//                                     <th>Subscription Id</th>
//                                     <th>Transaction id</th>
//                                     <th>Price</th>
//                                     <th>Total Amount</th>
//                                     <th>Source</th>
//                                     <th>Status</th>
//                                     <th>Payment Status</th>
//                                     <th>Expired</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Basic</a></td>
//                                     <td>#552030</td>
//                                     <td>#HDAC-101512012</td>
//                                     <td>20</td>
//                                     <td>14</td>
//                                     <td>6</td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td>13/06/2023</td>
//                                 </tr>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Premium</a></td>
//                                     <td>#552045</td>
//                                     <td>#ICIC-101512023</td>
//                                     <td>35</td>
//                                     <td>25</td>
//                                     <td>10</td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td>15/06/2023</td>
//                                 </tr>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Gold</a></td>
//                                     <td>#552050</td>
//                                     <td>#AXY-101512050</td>
//                                     <td>28</td>
//                                     <td>24</td>
//                                     <td>4</td>
//                                     <td><span className="text-clr-red">Expired</span></td>
//                                     <td><span className="text-clr-red">Expired</span></td>
//                                     <td>17/06/2023</td>
//                                 </tr>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Basic</a></td>
//                                     <td>#552055</td>
//                                     <td>#SBI-101512056</td>
//                                     <td>22</td>
//                                     <td>14</td>
//                                     <td>8</td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td>25/06/2023</td>
//                                 </tr>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Gold</a></td>
//                                     <td>#552060</td>
//                                     <td>#HDAC-1015123552</td>
//                                     <td>18</td>
//                                     <td>14</td>
//                                     <td>4</td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td><span className="text-clr-green2">Active</span></td>
//                                     <td>15/05/2023</td>
//                                 </tr>
//                                 <tr>
//                                     <td><a href="javascript:void(0);" className="site-text-primary">Basic</a></td>
//                                     <td>#552075</td>
//                                     <td>#HDAC-1015121503</td>
//                                     <td>20</td>
//                                     <td>14</td>
//                                     <td>6</td>
//                                     <td><span className="text-clr-red">Expired</span></td>
//                                     <td><span className="text-clr-red">Expired</span></td>
//                                     <td>08/05/2023</td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
// export default EmpPackagesPage;